module.exports = __webpack_public_path__ + "media/bootstrap-icons/save2-16cd039b.svg";